import { render, staticRenderFns } from "./ShutDownModal.vue?vue&type=template&id=6997a6a1&scoped=true"
import script from "./ShutDownModal.vue?vue&type=script&lang=js"
export * from "./ShutDownModal.vue?vue&type=script&lang=js"
import style0 from "./ShutDownModal.vue?vue&type=style&index=0&id=6997a6a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6997a6a1",
  null
  
)

export default component.exports